// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WMzw_","title":"styles_title__H0aly"};